import * as React from 'react';
import { Helmet } from 'react-helmet-async';

import { useQuery } from '@apollo/client/react';

import { ResponsiveContainer, Text } from '@clutter/clean';

import { HelpRootDocument } from '@graphql/landing';

import { Search } from './helpers/search';
import { Footer } from './layout/footer';
import { FooterCategories } from './layout/footer_categories';
import { FooterSupport } from './layout/footer_support';
import { FeaturedArticles } from './root/featured_articles';

export const Root: React.FC = () => {
  const { data } = useQuery(HelpRootDocument);

  return (
    <div>
      <Helmet>
        <title>Clutter | Help</title>
      </Helmet>
      <ResponsiveContainer>
        <Text.Title size="large">We’re Here to Help</Text.Title>
        <Search />
      </ResponsiveContainer>
      <FeaturedArticles articles={data?.articles} />
      <Footer>
        <FooterCategories />
        <FooterSupport />
      </Footer>
    </div>
  );
};
